import React from 'react';
import { useLocation } from 'react-router-dom';
import { LegalDocumentLink } from './legal/LegalDocumentViewer';
import './SiteBeianFooter.css';

const ICP_NUMBER = '苏ICP备2025227924号-1';
const GONGAN_NUMBER = '苏公网安备32011302323040号';
const GONGAN_RECORD_CODE = '32011302323040';
const COMPANY_NAME = '联采易（南京）科技有限公司';

const LEGAL_LINKS = [
  { slug: 'privacy_policy', label: '隐私政策' },
  { slug: 'platform_disclaimer', label: '免责声明' },
] as const;

type SiteBeianFooterProps = {
  /** 深色底页脚（如门户首页） */
  variant?: 'light' | 'dark';
  /** 嵌入其他页脚区域时，不因路由隐藏 */
  embedded?: boolean;
};

const shouldHideBeianFooter = (pathname: string) =>
  /-(h5)(\/|$)/.test(pathname) ||
  pathname === '/supplier-h5-login' ||
  pathname.startsWith('/im/') ||
  pathname === '/' ||
  pathname === '/home';

/**
 * PC 端页面底部备案信息（ICP + 公安备案 + 法律文档链接）
 */
const SiteBeianFooter: React.FC<SiteBeianFooterProps> = ({ variant = 'light', embedded = false }) => {
  const { pathname } = useLocation();

  if (!embedded && shouldHideBeianFooter(pathname)) {
    return null;
  }

  return (
    <footer
      className={`site-beian-footer site-beian-footer--${variant}`}
      aria-label="网站备案信息"
    >
      <div className="site-beian-footer__inner">
        <nav className="site-beian-footer__legal" aria-label="法律文档">
          {LEGAL_LINKS.map((item, index) => (
            <React.Fragment key={item.slug}>
              {index > 0 ? <span className="site-beian-footer__divider" aria-hidden /> : null}
              <LegalDocumentLink className="site-beian-footer__link" slug={item.slug}>
                {item.label}
              </LegalDocumentLink>
            </React.Fragment>
          ))}
        </nav>
        <span className="site-beian-footer__divider site-beian-footer__divider--block" aria-hidden />
        <span className="site-beian-footer__company">{COMPANY_NAME}</span>
        <span className="site-beian-footer__divider site-beian-footer__divider--block" aria-hidden />
        <a
          className="site-beian-footer__link"
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {ICP_NUMBER}
        </a>
        <span className="site-beian-footer__divider" aria-hidden />
        <a
          className="site-beian-footer__link site-beian-footer__gongan"
          href={`https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${GONGAN_RECORD_CODE}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="site-beian-footer__gongan-icon"
            src={`${process.env.PUBLIC_URL || ''}/beian/ghs.png`}
            alt=""
            width={16}
            height={16}
            loading="lazy"
          />
          {GONGAN_NUMBER}
        </a>
      </div>
    </footer>
  );
};

export default SiteBeianFooter;
